import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboardRanking = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 61,
	height: 60,
	viewBox: "0 0 61 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 30C0.5 13.4315 13.9315 0 30.5 0C47.0685 0 60.5 13.4315 60.5 30C60.5 46.5685 47.0685 60 30.5 60C13.9315 60 0.5 46.5685 0.5 30Z",
			fill: "#FFF7E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.38 16.875C17.8993 16.875 18.3201 17.2668 18.3201 17.75V41.375H43.703C44.2222 41.375 44.6431 41.7668 44.6431 42.25C44.6431 42.7332 44.2222 43.125 43.703 43.125H18.3201C17.8215 43.125 17.3433 42.9406 16.9906 42.6124C16.638 42.2842 16.4399 41.8391 16.4399 41.375V17.75C16.4399 17.2668 16.8608 16.875 17.38 16.875Z",
			fill: "#EB9D06"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.3159 29.125C22.1861 29.125 22.0809 29.2229 22.0809 29.3438V37.6562C22.0809 37.7771 22.1861 37.875 22.3159 37.875H24.6662C24.796 37.875 24.9012 37.7771 24.9012 37.6562V29.3438C24.9012 29.2229 24.796 29.125 24.6662 29.125H22.3159ZM20.2007 29.3438C20.2007 28.2564 21.1477 27.375 22.3159 27.375H24.6662C25.8344 27.375 26.7814 28.2564 26.7814 29.3438V37.6562C26.7814 38.7436 25.8344 39.625 24.6662 39.625H22.3159C21.1477 39.625 20.2007 38.7436 20.2007 37.6562V29.3438Z",
			fill: "#EB9D06"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M30.7769 26.5C30.6471 26.5 30.5418 26.5979 30.5418 26.7188V37.6562C30.5418 37.7771 30.6471 37.875 30.7769 37.875H33.1271C33.2569 37.875 33.3621 37.7771 33.3621 37.6562V26.7188C33.3621 26.5979 33.2569 26.5 33.1271 26.5H30.7769ZM28.6616 26.7188C28.6616 25.6314 29.6086 24.75 30.7769 24.75H33.1271C34.2953 24.75 35.2423 25.6314 35.2423 26.7188V37.6562C35.2423 38.7436 34.2953 39.625 33.1271 39.625H30.7769C29.6086 39.625 28.6616 38.7436 28.6616 37.6562V26.7188Z",
			fill: "#EB9D06"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M39.2163 23C39.0865 23 38.9813 23.0979 38.9813 23.2188V37.6562C38.9813 37.7771 39.0865 37.875 39.2163 37.875H41.5666C41.6964 37.875 41.8016 37.7771 41.8016 37.6562V23.2188C41.8016 23.0979 41.6964 23 41.5666 23H39.2163ZM37.1011 23.2188C37.1011 22.1314 38.0481 21.25 39.2163 21.25H41.5666C42.7348 21.25 43.6818 22.1314 43.6818 23.2188V37.6562C43.6818 38.7436 42.7348 39.625 41.5666 39.625H39.2163C38.0481 39.625 37.1011 38.7436 37.1011 37.6562V23.2188Z",
			fill: "#EB9D06"
		})
	]
});
export default SvgDashboardRanking;
